import { type ChangeEvent, useRef } from 'react'

import { EToastings } from '@/app/types/common'
import { onToasting } from '@/app/utils'
import { Modal } from '@/shared'

import style from './EditDocModal.module.scss'

interface IProps {
    editable: string
    onClose: () => void
    onChangeDocument: (file: Blob, fileName: string, onSuccess: () => void) => void
}

export const EditDocModal = (props: IProps) => {
    const { editable, onClose, onChangeDocument } = props

    const hiddenFileInput = useRef<HTMLInputElement | null>(null)

    const onTitleClick = () => {
        if (hiddenFileInput.current) {
            hiddenFileInput.current.click()
        }
    }

    const onHandleFile = (file: File) => {
        const fileNameContent = file.name.split('.')
        const currentExtention = file.name.split('.')[fileNameContent.length - 1]
        if (['pdf'].includes(currentExtention)) {
            onChangeDocument(file, editable, onClose)
        } else {
            onToasting({
                type: EToastings.ERROR,
                message: `Допускаются файлы с расширением PDF`
            })
        }
    }

    const onHandleFileChange = (event: ChangeEvent<HTMLInputElement>) => {
        event.preventDefault()

        if (event.target.files) {
            const fileUploaded = event.target.files[0]
            onHandleFile(fileUploaded)
        }
    }

    return (
        <Modal show={!!editable} onClose={onClose}>
            <div className={style.container}>
                <div className={style.blockHeader}>
                    <span>Изменить ссылку документа</span>
                </div>
                <iframe src={`${window.location.origin}/api/storage/${editable}`}></iframe>
                <div className={style.btn}>
                    <span className={style.btnTitle} onClick={onTitleClick}>
                        Загрузить документ
                    </span>
                    <div className={style.btnLoader}>
                        <input type='file' ref={hiddenFileInput} onChange={onHandleFileChange} />
                    </div>
                </div>
            </div>
        </Modal>
    )
}
